exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-list-item[data-v-31f22a4b]{margin-bottom:20px}.card-list-loading-container[data-v-31f22a4b]{position:absolute;bottom:40px;width:100%;text-align:center}.add-content-wrapper[data-v-31f22a4b]{height:125px;width:100%}.add-content-wrapper .add-content[data-v-31f22a4b]{text-align:center;line-height:125px;font-size:16px;cursor:pointer;color:#2a82e4;display:block}", ""]);

// exports
